import React, { useCallback, useState } from 'react';

import FormField from 'components/form/FormField.component';
import TextInput from 'components/form/TextInput.component';
import AnimatedCircle from 'components/generic/AnimatedCircle.component';
import ProgressLine from 'components/generic/ProgressLine.component';
import SidebarSkeleton from 'components/generic/SidebarSkeleton.component';

import CN from './UiPage.module.scss';

const ProgressBarPanel = () => {
  const [value, setValue] = useState(50);
  const handleChange = useCallback((ev) => void setValue(ev.raw), [setValue]);

  return (
    <div data-bem="ProgressBarPanel" className={CN.container}>
      <div className={CN.display}>
        <AnimatedCircle>img</AnimatedCircle>
        <FormField name="completed" input={TextInput} value={value} onChange={handleChange} />
        <ProgressLine value={value} />
        <ProgressLine value={value} color="splash" showNumber />
        <ProgressLine value={100} color="splash" showNumber />
        <ProgressLine value={40} color="alert" />
        <ProgressLine value={20} color="warn" />
        <ProgressLine value={1} color="alert" showNumber />
        <ProgressLine value={999} color="warn" showNumber />
        <br />
        <div className={CN.sidebarWrapper}>
          <div>SidebarSkeleton variant="header"</div>
          <SidebarSkeleton variant="header" tag="ProgressBarPanel__SidebarSkeleton" />
          <div>SidebarSkeleton variant="content"</div>
          <SidebarSkeleton variant="content" />
          <div>SidebarSkeleton variant="footer"</div>
          <SidebarSkeleton variant="footer" />
          <br />
          <div>SidebarSkeleton variant="row"</div>
          <SidebarSkeleton variant="row" />
        </div>
      </div>
    </div>
  );
};

export default ProgressBarPanel;
